export default "__VITE_ASSET__n7oPhktx__"